<template>
  <VcLayout column :class="`VcEmptyState ${size}`" :data-qa="dataQa">
    <VcLayout column>
      <VcImage v-if="currentImage" :image="currentImage" class="VcEmptyStateImage" />
      <div class="VcEmptyStateTitle">
        {{ title }}
      </div>
    </VcLayout>
    <VcLayout class="VcEmptyStateSubtitle" column>
      {{ subtitle }}
    </VcLayout>
    <slot name="buttonArea">
      <VcLayout v-if="button || (linkLabel && linkUrl)" column align-center>
        <VcButton
          v-if="button"
          small
          :block="false"
          :outlined="outlinedButton"
          :flavor="buttonFlavor"
          class="VcEmptyStateButton"
          @click="$emit('click')">
          {{ button }}
        </VcButton>
        <VcLink v-if="linkLabel && linkUrl" :url="linkUrl" :label="linkLabel" />
      </VcLayout>
    </slot>
  </VcLayout>
</template>

<script>
import VcLayout from '../VcLayout/VcLayout.vue';
import VcButton from '../VcButton/VcButton.vue';
import VcLink from '../VcLink/VcLink.vue';
import VcImage from '../VcImage/VcImage.vue';

export default {
  name: 'VcEmptyState',
  components: { VcImage, VcButton, VcLayout, VcLink },
  props: {
    size: {
      type: String,
      default: 'md',
      validator: (prop) => ['sm', 'md', 'lg'].includes(prop),
    },
    image: {
      type: [String, Object],
      comment:
        'This is the standard way to pass the image, the icon and svg props are for backward compatibility',
    },
    icon: {
      type: [String, Object],
      comment: 'url to some image, deprecated',
    },
    svg: {
      type: [String, Object],
      comment: 'using the svgImage design system object, deprecated',
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    button: {
      type: String,
      required: false,
    },
    outlinedButton: {
      type: Boolean,
      required: false,
    },
    linkLabel: {
      type: String,
      required: false,
    },
    linkUrl: {
      type: String,
      required: false,
    },
    dataQa: {
      type: String,
      default: 'VcEmptyState',
    },
  },
  computed: {
    currentImage() {
      // for backward compatibility
      return this.image || this.icon || this.svg;
    },
    buttonFlavor() {
      return this.outlinedButton ? 'secondary' : 'primary';
    },
  },
};
</script>

<style lang="scss" scoped>
.VcEmptyState,
.VcEmptyStateSubtitle {
  text-align: center;
  line-height: var(--size-value6);
}

.VcEmptyState {
  text-align: center;

  .VcEmptyStateImage {
    margin-bottom: var(--size-value4);
    height: 160px;
  }

  .VcEmptyStateTitle {
    font-weight: var(--font-weight-xl);
    line-height: 22px;
    padding-bottom: var(--size-value1);
    font-size: var(--font-size-small2);
  }

  .VcEmptyStateSubtitle {
    font-size: var(--font-size-x-small);
  }

  .VcEmptyStateButton {
    margin-top: var(--size-value4);
  }
}

.sm {
  .VcEmptyStateImage {
    height: 48px;
    margin-bottom: var(--size-value8);

    ::v-deep svg {
      width: 48px;
    }
  }
}

.lg {
  .VcEmptyStateImage {
    height: 280px;
    margin-bottom: var(--size-value8);

    ::v-deep svg {
      width: 280px;
    }
  }

  .VcEmptyStateTitle {
    font-weight: var(--font-weight-large);
    line-height: 22px;
    padding-bottom: var(--size-value2);
    font-size: var(--font-size-medium1);
  }
}
</style>
